import script from "./baseForm.vue?vue&type=script&lang=ts"
export * from "./baseForm.vue?vue&type=script&lang=ts"

export default script